import { render, staticRenderFns } from "./m2_header.vue?vue&type=template&id=4a381c7c&"
import script from "./header.js?vue&type=script&lang=js&"
export * from "./header.js?vue&type=script&lang=js&"
import style0 from "./m2_header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports